import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

/** GOVOPS-1125 — Public route opens hosted presenter deck (static HTML). */
const DemoDeckRedirect = () => {
  useEffect(() => {
    window.location.replace('/pilot-deck.html');
  }, []);

  return (
    <div className="rhs-pilot-demo rhs-pilot-demo--deck-loading">
      <p>Opening presenter deck…</p>
      <p className="rhs-muted">
        If nothing opens,{' '}
        <a href="/pilot-deck.html">click here</a>
        {' or '}
        <Link to="/demo">return to pilot demo</Link>.
      </p>
    </div>
  );
};

export default DemoDeckRedirect;
